import React from 'react';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';

const AuditTrail = () => {
  return (
      <React.Fragment>

     <h2 className="pt-5">Audit Trail</h2>
    <MDBTable bordered>
      <MDBTableHead>
        <tr>
          <th>Transaction Date</th>
          <th>Transaction</th>
          <th>User</th>
         
        
      
        </tr>
      </MDBTableHead>
      <MDBTableBody>
        <tr>  
          <td>Feb 2, 2021 09:00 AM</td>
         
          <td>Successfully saved Sales Transaction</td>
          <td>Jomel</td>
         
        </tr>
        <tr>  
          <td>Feb 2, 2021 09:15 AM</td>
         
          <td>Successfully saved Return Transaction</td>
          <td>Jomel</td>
         
        </tr>

        <tr>  
          <td>Feb 2, 2021 09:16 AM</td>
         
          <td>Deleted Sales Transaction</td>
          <td>Jomel</td>
         
        </tr>

        <tr>  
          <td>Feb 2, 2021 09:23 AM</td>
         
          <td>Successfully saved Receiving Transaction</td>
          <td>Jomel</td>
         
        </tr>

        <tr>  
          <td>Feb 2, 2021 09:58 AM</td>
         
          <td>Deleted Receiving Transaction</td>
          <td>Jomel</td>
         
        </tr>
      </MDBTableBody>
    </MDBTable>
    </React.Fragment>
  );
}

export default AuditTrail;